import React, { Component } from 'react';
import ReactDom from 'react-dom';

import { Post } from './Post';

class MainView extends Component {
	constructor() {
		super();
		this.state = {
			activePostIndex: 0
		}
		this.handleActivePostIndexChange = this.handleActivePostIndexChange.bind(this);
	}

	componentDidUpdate(prevProps, prevState) {
		if (this.state.activePostIndex !== prevState.activePostIndex) {
			this.ensureActiveItemVisible();
		}
	}
	ensureActiveItemVisible() {
		var postComponent = this.refs.activePost;
		if (postComponent) {
		  	var domNode = ReactDom.findDOMNode(postComponent);
		  	this.scrollElementIntoViewIfNeeded(domNode);
		}
	}
	scrollElementIntoViewIfNeeded(domNode) {
		domNode.scrollIntoView({behavior: 'smooth'});
	}
	handleActivePostIndexChange(i) {
		const {activePostIndex} = this.state;
		const { posts } = this.props;
		let change = activePostIndex + i;
		if (0 > change || posts.length - 1 < change) {
			change = 0;
		}
		this.setState({activePostIndex: change});

	}
	handleKeyPress = e => {
		if (
			e.key === 's' ||
			e.key === 'j'
		)
			this.handleActivePostIndexChange(1);
		if (
			e.key === 'w' ||
			e.key === 'k'
		) this.handleActivePostIndexChange(-1);
	}
	render() {
		const { posts } = this.props;
		const { activePostIndex } = this.state;

		const display_posts = posts.map((p,i) => {
			var moreprops = {};
			if (activePostIndex === i) {
				moreprops = {
					className: 'post-active',
					ref: 'activePost'
				}
			}
			return (
				<Post key={p.title} {...p} {...moreprops} />
			)
		});

		return (
			<main
				tabIndex="0"
				onKeyPress={this.handleKeyPress}
				className='site-body'
			>
				{ display_posts }
			</main>
		)
	}
}

export default MainView;



// WEBPACK FOOTER //
// ./src/Views.js